var _path;
const _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
import { forwardRef } from "react";
const SvgHealth = (_ref, ref) => {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: ref,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M9.51152 24V14.5991H0V9.34562H9.51152V0H14.765V9.34562H24V14.5991H14.765V24H9.51152ZM13.9355 13.7696H23.1705V10.1751H13.9355V0.829493H10.341V10.1751H0.829493V13.7696H10.341V23.1705H13.9355V13.7696Z",
    fill: "#4D523C"
  })));
};
const ForwardRef = /*#__PURE__*/forwardRef(SvgHealth);
export { ForwardRef as ReactComponent };
export default "data:image/svg+xml;base64,PHN2ZyB3aWR0aD0iMjQiIGhlaWdodD0iMjQiIHZpZXdCb3g9IjAgMCAyNCAyNCIgZmlsbD0ibm9uZSIgeG1sbnM9Imh0dHA6Ly93d3cudzMub3JnLzIwMDAvc3ZnIj4KPHBhdGggZmlsbC1ydWxlPSJldmVub2RkIiBjbGlwLXJ1bGU9ImV2ZW5vZGQiIGQ9Ik05LjUxMTUyIDI0VjE0LjU5OTFIMFY5LjM0NTYySDkuNTExNTJWMEgxNC43NjVWOS4zNDU2MkgyNFYxNC41OTkxSDE0Ljc2NVYyNEg5LjUxMTUyWk0xMy45MzU1IDEzLjc2OTZIMjMuMTcwNVYxMC4xNzUxSDEzLjkzNTVWMC44Mjk0OTNIMTAuMzQxVjEwLjE3NTFIMC44Mjk0OTNWMTMuNzY5NkgxMC4zNDFWMjMuMTcwNUgxMy45MzU1VjEzLjc2OTZaIiBmaWxsPSIjNEQ1MjNDIi8+Cjwvc3ZnPgo=";